import { cva } from "class-variance-authority";

// **`cursor-pointer` is not a house choice — it is MUI's.** `ButtonBase` sets
// `cursor: 'pointer'` on its root (`ButtonBase.js:63`), and every button on a
// ported screen is a `ButtonBase`. Tailwind v4's preflight dropped v3's
// `button { cursor: pointer }` reset and nothing here put it back, so the whole
// app's buttons hovered under the plain arrow while the app's own hand-rolled
// controls — the menu rows, the alert's close — carried the hand.

/**
 * The reset every MUI `ButtonBase` carries that a bare `<button>` does not:
 * the pointer, no text selection, no tap flash on touch — and the plain arrow
 * again once disabled (`ButtonBase.js:52,63,64,76-80`).
 *
 * For hand-rolled controls on ported screens that MUI would have drawn with a
 * `ButtonBase`, where `buttonVariants` itself is the wrong shape.
 */
export const MUI_BUTTON_BASE_RESET =
  "cursor-pointer select-none [-webkit-tap-highlight-color:transparent] disabled:cursor-default";

export const buttonVariants = cva(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
